/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevIngestionRunDto
 */
export interface DevIngestionRunDto {
    /**
     * 
     * @type {string}
     * @memberof DevIngestionRunDto
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof DevIngestionRunDto
     */
    ingestionType: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevIngestionRunDto
     */
    currentState: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DevIngestionRunDto
     */
    startedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DevIngestionRunDto
     */
    failedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DevIngestionRunDto
     */
    failedStep: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevIngestionRunDto
     */
    failureType: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevIngestionRunDto
     */
    failureReason: string | null;
}

/**
 * Check if a given object implements the DevIngestionRunDto interface.
 */
export function instanceOfDevIngestionRunDto(value: object): value is DevIngestionRunDto {
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('ingestionType' in value) || value['ingestionType'] === undefined) return false;
    if (!('currentState' in value) || value['currentState'] === undefined) return false;
    if (!('startedAt' in value) || value['startedAt'] === undefined) return false;
    if (!('failedAt' in value) || value['failedAt'] === undefined) return false;
    if (!('failedStep' in value) || value['failedStep'] === undefined) return false;
    if (!('failureType' in value) || value['failureType'] === undefined) return false;
    if (!('failureReason' in value) || value['failureReason'] === undefined) return false;
    return true;
}

export function DevIngestionRunDtoFromJSON(json: any): DevIngestionRunDto {
    return DevIngestionRunDtoFromJSONTyped(json, false);
}

export function DevIngestionRunDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevIngestionRunDto {
    if (json == null) {
        return json;
    }
    return {
        
        'correlationId': json['correlationId'],
        'ingestionType': json['ingestionType'],
        'currentState': json['currentState'],
        'startedAt': (json['startedAt'] == null ? null : new Date(json['startedAt'])),
        'failedAt': (json['failedAt'] == null ? null : new Date(json['failedAt'])),
        'failedStep': json['failedStep'],
        'failureType': json['failureType'],
        'failureReason': json['failureReason'],
    };
}

export function DevIngestionRunDtoToJSON(json: any): DevIngestionRunDto {
    return DevIngestionRunDtoToJSONTyped(json, false);
}

export function DevIngestionRunDtoToJSONTyped(value?: DevIngestionRunDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correlationId': value['correlationId'],
        'ingestionType': value['ingestionType'],
        'currentState': value['currentState'],
        'startedAt': (value['startedAt'] == null ? null : (value['startedAt'] as any).toISOString()),
        'failedAt': (value['failedAt'] == null ? null : (value['failedAt'] as any).toISOString()),
        'failedStep': value['failedStep'],
        'failureType': value['failureType'],
        'failureReason': value['failureReason'],
    };
}

